import { Component, OnDestroy, AfterContentInit, OnInit, ChangeDetectorRef, ElementRef, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import {
  DocumentClassDTO,
  CircuitDTO,
  ProcedureCircuitDTO,
  WorkProcedureCircuitDTO,
  getSimpleIdentifierFromString,
  CircuitStepDTO,
  TypeStepDTO,
  CircuitCommunicationDTO,
  ProfileDTO,
  MasterDataDTO,
  DocumentDTO,
  CircuitCommunicationAgentDTO,
  CircuitCommunicationAgentTypeDTO,
  ProfileInboxDTO,
  OrganizationalUnitDTO,
  TaskDTO,
  CircuitConfigDTO
} from '../../api/plyca-dtos';
import { FieldConfig } from '../../api/contract-notice-dto';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { MenuItem, SelectItem } from 'primeng-lts/api';
import { catchError, finalize, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { PaginationDTO } from '../../api/PaginationModel';
import { EMPTY, forkJoin, iif, Observable, of, throwError } from 'rxjs';
import {
  ActionParameterDefinitionDTO,
  CircuitFilterModeDTO, CompanyDTO, ProjectEntityDTO, ResultTypeDTO,
} from '../../api/plyca-dtos-v2';
import * as lodash from 'lodash';
import { UserService } from '../../user.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { searchGenericComponent, SearchSettingDTOModal } from '../../components/search/searchGeneric.component';
import { basicDocumentComponent } from '../../documents/basicDocument/basicDocument.component';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { FormConfig, FunctionDef, TemplateDef } from '../../components/forms/form.objects';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { generateRandomIdentifier } from '../../ui.service';

const MANUALTYPECIRCUITID = 'XPLITE';
export const MANUALPROCESSINGMODE_ID = '9';

const STEP_PROFILE_PROPERTY = 'profileList';
const OU_PROFILE_PROPERTY = 'organizationalUnit';
const DOCCLASSOPTIONS_OTHER_ID = '-1#OTHER';

enum ReceiverAlias {
  RECEIVER_AWARDED = 'AWARDED',
  RECEIVER_NOTAWARDED = 'NOTAWARDED',
  // RECEIVER_AWARD_ALL = 'NOTAWARDED_ALL',
  RECEIVER_EXCLUDED = 'EXCLUDED',
  PENDING_INVITATIONS = 'PENDING_INVITATIONS'
}

interface ProcedureCircuitModel extends WorkProcedureCircuitDTO {
  documentClassOptions: Array<DocumentClassDTO>;
  editDivisionPhase: boolean;
  document: DocumentDTO;
  notificationConfigSelection: CircuitCommunicationDTO;
}

@Component({
  selector: 'procedureCircuit',
  templateUrl: 'procedureCircuit.template.html',
  providers: [DialogService]
})
export class ProcedureCircuitComponent extends BaseFormComponent<ProcedureCircuitDTO, ProcedureCircuitModel>
  implements OnDestroy, AfterContentInit, OnInit {

  public circuits: SelectItem[];
  private profileFieldConfig: FieldConfig;
  private inboxFieldConfig: FieldConfig;
  private messageTextFieldConfig: FieldConfig;
  public stepTableColumns: string[];
  public pubTableColumns: string[];
  public commTableColumns: string[];
  public stepTypes: MenuItem[];
  // variable para hacer uso enumerado en template
  public TypeStepDTO = TypeStepDTO;

  // variables guardar
  public orgUnitFieldConfig: FieldConfig;
  public showSaveCircuit = false;
  public circuitsToSave: SelectItem[];
  public selectedSaveCircuit: CircuitDTO | string;
  public organizationalUnitToSave: OrganizationalUnitDTO;

  public showPublications = false;
  public showNotifications = false;
  public locale = null;

  public showImportCircuit = false;
  public circuitToImport: CircuitDTO;

  public addDocumentSelection = true;
  public selectAddDocument = [
    { name: this.translate.instant('ProcedureCircuit.Lbl.Anexar'), code: true },
    { name: this.translate.instant('ProcedureCircuit.Lbl.Solicitar'), code: false }
  ];

  private profileList: ProfileDTO[];
  private project: ProjectEntityDTO;
  private notificationCompany: CompanyDTO;
  public notificationReceiverTypes: MenuItem[];
  public receiversModel: Array<CircuitCommunicationAgentDTO>;
  public publicationItems: MenuItem[];
  public notificactionItems: MenuItem[];
  public receiversColumns: string[];

  public dummyArray = [1];
  @ViewChild('stepsTemplate', { read: ViewContainerRef, static: true })
  private stepsTemplate: TemplateRef<any>;

  constructor(
    elem: ElementRef,
    public helpService: HelpService,
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialogConfig: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef
  ) {
    super(elem);
    this.loadFormFieldsConfig();
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.ADD_PROCEDURE));
    this.circuits = [];
    this.circuitsToSave = [];
    this.stepTableColumns = [
      this.translate.instant('ProcedureCircuit.Lbl.TaskType'),
      this.translate.instant('General.profile'),
      this.translate.instant('Audit.box'),
      this.translateService.instant('General.actions')
    ];
    this.pubTableColumns = [
      this.translate.instant('ProcedureCircuit.Lbl.TaskType'),
      this.translate.instant('ProcedureCircuit.Lbl.Activity'),
      this.translateService.instant('General.actions')
    ];
    this.commTableColumns = [
      this.translate.instant('ProcedureCircuit.Lbl.TaskType'),
      this.translate.instant('DossierInfo.sections.COMMUNICATIONS.name'),
      this.translateService.instant('General.actions')
    ];
    this.receiversColumns = [
      this.translate.instant('ProcedureCircuit.Lbl.Destinations'),
      this.translateService.instant('General.actions')
    ]
    if (this.dialogConfig?.data) {
      if (!this.dialogConfig.data.dossierId) {
        const errorMsg = 'Error de configuracion, falta el parámetro con el identificador de expediente';
        this.uiService.showMessage(errorMsg, this.translateService.instant('General.error'));
        throw new Error(errorMsg);
      }
      this.windowHash = generateRandomIdentifier();
    }
  }

  protected preLoadForm(): Observable<any> {
    let obs: Observable<any>;
    if (!this.task && this.dialogConfig) {
      obs = this.plycaService.get<ProjectEntityDTO>(this.configuration.PROJECTENTITY_SERVICE_URL,
        this.dialogConfig.data.dossierId,
        {
          expand: 'expansionSet:minimal'
        });
    } else {
      obs = of(this.task.division?.project);
    }
    if (this.task?.work) {
      let w: WorkProcedureCircuitDTO = this.task.work as unknown as WorkProcedureCircuitDTO;
      if (w.desiredLocale)
        this.locale = w.desiredLocale;
    }
    return obs.pipe(
      tap((project: ProjectEntityDTO) => {
        if (!project) {
          const errorMsg = 'No existe el expediente consultado, propuestaid: ' + this.dialogConfig.data.dossierId;
          this.uiService.showMessage(errorMsg, this.translateService.instant('General.error'));
        } else {
          this.project = project;
        }
      })
    );
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    if (!formConfig?.functions) {
      formConfig.functions = [];
    }
    formConfig.functions.push({
      identifier: 'changeDocumenClass',
      fn: this.changeDocumenClass.bind(this)
    });
    formConfig.functions.push({
      identifier: 'getProject',
      fn: this.getProject.bind(this)
    });
    formConfig.functions.push({
      identifier: 'loadProfiles',
      fn: this.loadProfiles.bind(this)
    });
    return forkJoin([
      this.getDocumentClassWithConfig(),
      this.loadProfilesObservable(),
      this.loadCircuitsObservable(),
      this.loadDocument(),
      this.loadPublicationList(),
      this.loadNotificationList(),
      this.loadNotificationAgents()
    ]).pipe(
      switchMap(() => super.configureFormConfig(formConfig)),
      finalize(() => {
        this.updatePublicationsAndNotificationsVisibility();
        this.loadNotificationReceiverTypes();
        this.updateCircuitStepTypes();
        this.waitService.cancelWaiting();
      })
    );
  }

  // Metodos BaseFormComponent
  getFormSettingURL(): string {
    return '/dossier/procedures/procedureCircuit.json';
  }

  getServiceURL(operation?: string): string {
    return this.configuration.PROCEDURECIRCUIT_SERVICE_URL;
  }

  getObjectIdentifier() {
    return undefined;
  }

  dtoToModel(dto: ProcedureCircuitDTO): Observable<ProcedureCircuitModel> {
    let model: ProcedureCircuitModel;
    if (this.task) {
      model = this.task.work as unknown as ProcedureCircuitModel;
      if (!model) {
        throw Error(this.translate.instant('ProcedureCircuit.Error.Config'));
      }
      if (!model.procedureCircuit) {
        model.procedureCircuit = new ProcedureCircuitDTO();
      }
      model.procedureCircuit.division = this.task.division;
    } else {
      model = {} as ProcedureCircuitModel;
      model.procedureCircuit = new ProcedureCircuitDTO();
      model.procedureCircuit.circuit = new CircuitDTO();
      if (this.dialogConfig?.data?.document) {
        const doc = this.dialogConfig.data.document;
        model.procedureCircuit.circuit.documentClass = new DocumentClassDTO();
        model.procedureCircuit.circuit.documentClass.identifier = doc.entity?.documentClass?.identifier;
        model.orderNumber = doc.entity?.orderNumber;
        model.document = doc;
        model.phase = doc.phase;
        model.procedureCircuit.circuit.phase = model.phase;
        model.procedureCircuit.division = doc.entity?.division;
      }
    }
    if (model.orderNumber && model.procedureCircuit) {
      // si la configuración marca numero de orden del documento asociarlo a la definicion del circuito
      model.procedureCircuit.orderNumber = model.orderNumber;
    }
    if (model.circuitsDocuments?.length === 1 && !model.procedureCircuit?.circuit?.documentClass) {
      model.procedureCircuit.circuit.documentClass = model.circuitsDocuments[0];
    }
    model.documentClassOptions = new Array<DocumentClassDTO>();
    model.editDivisionPhase = this.task === undefined;
    this.setAdvancedMode(model);
    this.setDocumentClassOptions(model);
    if (!model.procedureCircuit.circuit.config) {
      model.procedureCircuit.circuit.config = new CircuitConfigDTO();
    }
    if (model.procedureCircuit.circuit.config.notifications?.length > 0) {
      this.receiversModel = model.procedureCircuit.circuit.config?.notifications[0]?.receivers;
      model.notificationConfigSelection = model.procedureCircuit.circuit.config.notifications[0];
    } else {
      model.procedureCircuit.circuit.config.notifications = [];
    }

    // consultas adicionales
    return iif(() => model.procedureCircuit?.circuit?.documentClass?.identifier !== undefined
      && model.procedureCircuit?.circuit?.documentClass.abbreviation === undefined,
      this.plycaService.get<DocumentClassDTO>(this.configuration.DOCUMENTCLASS_SERVICE_URL,
        model.procedureCircuit.circuit.documentClass?.identifier).pipe(
          tap((document: DocumentClassDTO) => model.procedureCircuit.circuit.documentClass = document)
        ),
      of({})
    ).pipe(
      switchMap(() => of(model))
    );
  }

  private setDocumentClassOptions(model: ProcedureCircuitModel, additionalDocClass?: DocumentClassDTO) {
    let documentClassOptions = model.documentClassOptions;
    documentClassOptions.splice(0);
    if (model.circuitsDocuments) {
      documentClassOptions.push(...model.circuitsDocuments);
    }
    if (additionalDocClass) {
      documentClassOptions.push(additionalDocClass);
    }
    // añadir opción adicional al combo de documentos posibles la opción de abrir buscador
    if (model.documentClassSearchId) {
      documentClassOptions.push({
        identifier: DOCCLASSOPTIONS_OTHER_ID,
        name: this.translate.instant('ProcedureCircuit.Lbl.OtherClassOptions')
      } as DocumentClassDTO);
    }
    this.sortDocumentClassOptions(documentClassOptions);
  }

  private sortDocumentClassOptions(documentClassOptions: DocumentClassDTO[]) {
    documentClassOptions.sort((doc1, doc2) => {
      if (doc1?.identifier === DOCCLASSOPTIONS_OTHER_ID) {
        return 1;
      }
      if (doc2?.identifier === DOCCLASSOPTIONS_OTHER_ID) {
        return -1;
      }
      const a = doc1?.name;
      const b = doc2?.name;
      if (a > b) {
        return 1;
      }
      if (b > a) {
        return -1;
      }
      return 0;
    });
  }

  modelToDTO(model: WorkProcedureCircuitDTO): ProcedureCircuitDTO {
    let procedureCircuit = lodash.cloneDeep(this.model.procedureCircuit);
    this.updateCircuitFromModel(procedureCircuit.circuit);
    if (this.model.notificationConfigSelection) {
      if (this.receiversModel) {
        this.model.notificationConfigSelection.receivers = [... this.receiversModel];
      }
      const notificationConfigSelectionList = [];
      notificationConfigSelectionList.push(this.model.notificationConfigSelection);
      procedureCircuit.circuit.config.notifications = notificationConfigSelectionList;
    }
    return procedureCircuit;
  }

  private updateCircuitFromModel(circuit: CircuitDTO): void {
    if (circuit.config?.notifications?.length > 0) {
      circuit.config.notifications[0].receivers = this.receiversModel;
    }
    this.cleanCircuit(circuit);
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'ProcedureCircuit.Lbl.Title';
    headerInfo.titleIcon = 'fa fa-lg fa-tasks';
    headerInfo.project = this.project;
    return headerInfo;
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'ProcedureCircuit.Lbl.Save',
        'fas fa-star',
        'btn-outline-secondary',
        true,
        this.windowHash,
        () => this.showCircuits()
      ),
      () => {
        this.setShowSaveCircuit(true);
      });
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'ProcedureCircuit.Lbl.Import',
        'fas fa-cloud-download-alt',
        'btn-outline-primary',
        true,
        this.windowHash,
        () => this.showCircuits() && this.circuits?.length > 0
      ),
      () => {
        this.showImportCircuit = true;
      });
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash,
        () => this.acceptEnabled()
      ),
      () => {
        this.accept();
      });
    this.headerActionsService.addWindowDivider(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash,
      ),
      () => {
        if (this.task) {
          this.salir();
        } else {
          this.dialogRef.close();
        }
      });
  }
  // Fin Metodos BaseFormComponent

  private acceptEnabled(): boolean {
    return this.model?.procedureCircuit?.division?.identifier !== undefined
      && this.project?.identifier !== undefined
      && this.model?.procedureCircuit?.circuit?.documentClass?.identifier !== undefined;
  }

  ngOnDestroy(): void {
    this.dialogRef = null;
    this.dialogService = null;
    this.dialogConfig = null;
    super.ngOnDestroy();
  }

  private updatePublicationsAndNotificationsVisibility(): void {
    this.setShowPublicationsVisible(this.model.mustBePublished || this.model.procedureCircuit?.circuit?.config?.publications?.length > 0);
    this.setShowNotificationsVisible(this.model.mustBeNotified
      || this.model.procedureCircuit?.circuit?.config?.notifications?.length > 0);
    this.loadNotificationReceiverTypes();
  }

  public showCircuits(): boolean {
    return this.model?.procedureCircuit?.division?.identifier !== undefined
      && this.model?.procedureCircuit?.circuit?.documentClass?.identifier !== undefined
      && this.model?.procedureCircuit?.circuit?.phase?.identifier !== undefined;
  }

  public loadCircuitsObservable(initCircuit = true): Observable<any> {
    let observable: Observable<any>;
    if (this.showCircuits()) {
      this.showNotifications = false;
      this.showPublications = false;
      const query = {
        documentClassId: this.model.procedureCircuit?.circuit?.documentClass?.identifier,
        phase: getSimpleIdentifierFromString(this.model.procedureCircuit?.circuit?.phase?.identifier),
        organizationalUnit: this.project?.organizationalUnit?.identifier,
        useRecursiveOrganizationalUnit: 'true',
        typeCircuit: MANUALTYPECIRCUITID,
        modoInicioTramite: (this.model?.procedureCircuit?.orderNumber !== undefined) ? 'SUBSANACION' : 'NUEVO_TRAMITE',
        modeFilter: CircuitFilterModeDTO.All,
        expand: 'organizationalUnit',
        sort: 'identifier asc'
      };
      if (this.model?.document?.entity?.orderNumber !== undefined) {
        query['orderNumber'] = '' + this.model.document.entity.orderNumber;
      }

      observable = forkJoin([
        this.plycaService.query<CircuitDTO>(this.configuration.CIRCUIT_SERVICE_URL, query).pipe(
          map((result: PaginationDTO<CircuitDTO>) => (result?.content) ? result.content : []),
          catchError((error: any) => {
            this.errorHandler.showServerError(error);
            return of(undefined);
          })
        ),
        this.plycaService.query<ProcedureCircuitDTO>(this.configuration.PROCEDURECIRCUIT_SERVICE_URL, {
          documentClassAbbreviation: this.model.procedureCircuit?.circuit?.documentClass?.abbreviation,
          phase: getSimpleIdentifierFromString(this.model.procedureCircuit?.circuit?.phase?.identifier),
          organizationalUnit: this.project?.organizationalUnit?.identifier,
          projectTypeCode: (this.project?.classification?.typeCode.identifier) ?
            getSimpleIdentifierFromString(this.project?.classification.typeCode.identifier) : '',
          page: '0',
          size: '1',
          sort: 'procedure.startInfo.date,desc'
        }).pipe(
          map((result: PaginationDTO<ProcedureCircuitDTO>) => (result?.content) ?
            result.content.map((procedureCircuit: ProcedureCircuitDTO) => procedureCircuit.circuit)
            : []
          ),
          map((circuits: Array<CircuitDTO>) => this.filterAvaliableCircuits(circuits)),
          catchError((error: any) => {
            this.errorHandler.showServerError(error);
            return of(undefined);
          })
        )
      ]).pipe(
        tap((circuits: Array<Array<CircuitDTO>>) => {
          this.circuits.splice(0);
          this.circuitsToSave.splice(0);
          // circuitos
          let resultCircuit = circuits[0] as Array<CircuitDTO>;
          if (resultCircuit) {
            let selectItem: SelectItem;
            resultCircuit.forEach((circuit: CircuitDTO) => {
              this.orderCircuitSteps(circuit);
              selectItem = { label: circuit.name, value: circuit };
              this.circuits.push(selectItem);
              if (this.project?.organizationalUnit?.identifier
                && circuit?.organizationalUnit?.identifier === this.project?.organizationalUnit?.identifier) {

                // solo permitimos guardar los circuitos de mi unidad
                this.circuitsToSave.push(selectItem)
              }
            });
          }
          let resultProcCircuit = circuits[1] as Array<CircuitDTO>;
          let suggestedCircuit: CircuitDTO;
          if (resultProcCircuit && resultProcCircuit.length > 0) {
            suggestedCircuit = resultProcCircuit[0];
            this.circuits.splice(0, 0,
              { label: this.translateService.instant('ProcedureCircuit.Msg.LastUsedCircuit'), value: suggestedCircuit });
          } else if (resultCircuit && resultCircuit.length > 0) {
            suggestedCircuit = resultCircuit[0];
          }
          // si no hay circuitos inicializar configuracion
          if (initCircuit) {
            if (this.isCircuitDefinitionEmpty()) {
              if (suggestedCircuit) {
                this.setCircuit(suggestedCircuit);
              } else {
                this.initCircuitConfiguration();
              }
            }
            // seleccionar opcion de anexar documento en pantalla si es un DocNoestruc y
            // hay numero de orden asociado a la tarea (y por lo tanto documento), o no se ha definido paso de cumplimentar
            // TODO en algún momento no viene tipo de documento
            this.addDocumentSelection =
              (!this.model.procedureCircuit?.circuit?.documentClass?.configuration ||
                this.model.procedureCircuit?.circuit?.documentClass?.configuration?.table === 'DOCNOESTRUC')
              && (this.model.procedureCircuit?.orderNumber !== undefined
                || !this.existsStepType(TypeStepDTO.Cumplimenta));
            this.changeAddDocument({ value: this.addDocumentSelection });
          }
          this.organizationalUnitToSave = this.model.procedureCircuit?.circuit?.organizationalUnit;
        }),
        tap(() => {
          // Establecer circuito por defecto a importar
          if (this.circuits.length > 0) {
            this.circuitToImport = this.circuits[0].value;
          }
        })
      );
    } else {
      this.circuits.splice(0);
      observable = of({});
    }
    return observable.pipe(
      finalize(() => {
        this.updatePublicationsAndNotificationsVisibility();
        this.updateCircuitStepTypes();
      })
    )
  }
  private filterAvaliableCircuits(circuits: CircuitDTO[]): CircuitDTO[] {
    let avaliableCircuits: CircuitDTO[];
    if (this.model.procedureCircuit?.orderNumber) {
      const currentState = this.model.document?.currentState?.identifier;
      if (!currentState) {
        console.error('No se ha podido obtener el estado del documento por lo que se inhabilita la carga de circuitos existentes'
          , this.model?.document);
        avaliableCircuits = [];
      } else if (this.isDocumentStateValidOk(currentState)) {
        // Solo se pueden circuitos con tareas de validar y/o firmar -> eliminar circuitos con tareas de anexar/cumplimentar o revisar
        avaliableCircuits = circuits.filter((circuit: CircuitDTO) => circuit.config?.listCircuitStepDTO?.length > 0
          && circuit.config.listCircuitStepDTO.find((step: CircuitStepDTO) => step.typeStep === TypeStepDTO.Revisa) === undefined);
      } else if (this.isDocumentStateSignedOk(currentState)) {
        // Solo se pueden circuitos con tareas de firma -> eliminar circuitos con tareas de anexar/cumplimentar o revisar
        avaliableCircuits = circuits.filter((circuit: CircuitDTO) => circuit.config?.listCircuitStepDTO?.length > 0
          && circuit.config.listCircuitStepDTO.find((step: CircuitStepDTO) => step.typeStep === TypeStepDTO.Revisa
            || step.typeStep === TypeStepDTO.Valida) === undefined);
      } else {
        avaliableCircuits = circuits;
      }
    } else {
      avaliableCircuits = circuits;
    }
    return avaliableCircuits;
  }

  private changeDocumenClass(newValue: DocumentClassDTO, event: {
    oldValue: DocumentClassDTO,
    newValue: DocumentClassDTO
  }): void {
    if (this.model?.procedureCircuit?.circuit) {
      this.model.procedureCircuit.circuit.config = undefined;
    }
    if (event?.newValue?.identifier === undefined) {
      // actualizar combo de documentos disponibles con configuracion de tarea
      this.setDocumentClassOptions(this.model);
    } else if (event?.newValue?.identifier === DOCCLASSOPTIONS_OTHER_ID) {
      // abrir buscador
      this.openDocumentClassSelector(event.oldValue);
    } else if (event.newValue.identifier !== event?.oldValue?.identifier) {
      this.subscribe(
        this.getDocumentClassWithConfig().pipe(
          switchMap(() => this.loadCircuitsObservable())
        )
      );
    }
  }

  private getDocumentClassWithConfig(): Observable<DocumentClassDTO> {
    return iif(() => !this.model.procedureCircuit?.circuit?.documentClass?.configuration?.table
      && this.model.procedureCircuit?.circuit?.documentClass?.identifier
      && this.model.procedureCircuit?.circuit?.documentClass?.identifier !== DOCCLASSOPTIONS_OTHER_ID,
      this.plycaService.get<DocumentClassDTO>(this.configuration.DOCUMENTCLASS_SERVICE_URL,
        this.model.procedureCircuit?.circuit?.documentClass?.identifier, { 'expand': 'configuration' }).pipe(
          tap((documentClass: DocumentClassDTO) => this.model.procedureCircuit.circuit.documentClass = documentClass),
          catchError((error: any) => {
            console.error('Error al leer configuracion del documento' +
              this.model.procedureCircuit?.circuit?.documentClass?.identifier, error);
            return of(this.model.procedureCircuit?.circuit?.documentClass);
          })
        ),
      of(this.model.procedureCircuit?.circuit?.documentClass));
  }

  private openDocumentClassSelector(previousValue: DocumentClassDTO): void {
    let contextSearch = new SearchSettingDTOModal(this.model.documentClassSearchId, true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose.pipe(
      switchMap((documentClass: DocumentClassDTO) => {
        if (documentClass) {
          return of(documentClass);
        } else {
          // saltarse todo porque no se selecciono documento
          return EMPTY;
        }
      }),
      tap((documentClass: DocumentClassDTO) => {
        this.setDocumentClassOptions(this.model, documentClass);
        this.model.procedureCircuit.circuit.documentClass = documentClass;
      }),
      switchMap(() => this.getDocumentClassWithConfig()),
      switchMap(() => this.loadCircuitsObservable())
    ));

  }

  public saveCircuit(): void {
    let circuit = this.model?.procedureCircuit?.circuit;
    if (circuit && this.selectedSaveCircuit && this.organizationalUnitToSave.identifier) {
      let obs: Observable<any>;
      this.waitService.startWaiting();
      // clonar circuito editado en pantalla para no modificarlo al limpiarlo y enviarlo al servidor
      const editedClonedCircuit = this.cloneAndCleanCircuit(circuit);
      editedClonedCircuit.organizationalUnit = this.organizationalUnitToSave;
      if (this.isNullOrStringCircuit(this.selectedSaveCircuit)) {
        // nuevo circuito
        editedClonedCircuit.identifier = undefined;
        editedClonedCircuit.typeCircuit = new MasterDataDTO(MANUALTYPECIRCUITID, 'TR_TIPO_CIRCUITO');
        editedClonedCircuit.processingMode = new MasterDataDTO(MANUALPROCESSINGMODE_ID, 'MODO_TRAMITACION');
        editedClonedCircuit.name = this.selectedSaveCircuit as string;
        this.updateCircuitFromModel(editedClonedCircuit);
        // insert del circuito
        obs = this.plycaService.insert(this.configuration.CIRCUIT_SERVICE_URL, editedClonedCircuit).pipe(
          tap((updated: CircuitDTO) => {
            circuit.identifier = updated.identifier;
          })
        );
      } else {
        // update del circuito -> clonar seleccionado para no modificarlo y cambiar configuracion
        let selectedClonedCircuit = this.cloneAndCleanCircuit(this.selectedSaveCircuit as CircuitDTO);
        selectedClonedCircuit.config = editedClonedCircuit.config
        this.updateCircuitFromModel(selectedClonedCircuit);
        obs = this.plycaService.update(this.configuration.CIRCUIT_SERVICE_URL, selectedClonedCircuit);
      }
      this.subscribe(obs.pipe(
        tap((updated: CircuitDTO) => {
          this.uiService.showSuccess(this.translate.instant('ProcedureCircuit.Msg.SavedOk'),
            this.translateService.instant('General.info'),
            'success');
        }),
        mergeMap(() => this.loadCircuitsObservable(false)),
        catchError((error: any) => {
          this.errorHandler.showServerError(error);
          return throwError(error);
        }),
        finalize(() => {
          this.waitService.cancelWaiting();
          this.showSaveCircuit = false;
        })
      ));
    }
  }

  public getSavedCircuits(): SelectItem[] {
    let savedCircuits: SelectItem[];
    if (this.circuits) {
      savedCircuits = this.circuits.filter(item => item.value?.identifier !== undefined);
    }
    return savedCircuits;
  }

  private loadFormFieldsConfig(): void {
    this.profileFieldConfig = {
      'id': 'profile',
      'type': 'DROPDOWN',
      'dataConfig': {
        'jsonPath': 'profileList'
      },
      'dinamicOptionsActive': true,
      'dropDownDataKey': 'description',
      'jsonField': 'profile',
      'showInfo': this.userService.getUserPreferences()?.mainViewPrefs?.showHelpTags
    } as FieldConfig;
    this.inboxFieldConfig = {
      'id': 'profile',
      'type': 'SEARCH',
      'idBuscador': 'INBOX',
      'jsonField': 'inbox',
      'editable': '$model.profile?.identifier !== undefined && $model.profile.identifier != 71',
      'parameters': [
        {
          'identifier': 'PERFILBUZON.PERID',
          'value': '$model.profile?.identifier'
        },
        {
          'identifier': 'ORGANISMO.RUTA',
          'value': '$model.organizationalUnit'
        }
      ],
      'autoSearch': true,
      'showInfo': this.userService.getUserPreferences()?.mainViewPrefs?.showHelpTags
    } as FieldConfig;
    this.messageTextFieldConfig = {
      'description': this.translate.instant('ProcedureCircuit.Field.Msg'),
      'type': 'TEXTAREA',
      'jsonField': 'idMessage',
      'showInfo': this.userService.getUserPreferences()?.mainViewPrefs?.showHelpTags
    } as FieldConfig;
    this.orgUnitFieldConfig = {
      'descriptionKey': 'DocumentsSearch.organizationalUnitId',
      'tooltipText': 'DocumentsSearch.organizationalUnitId',
      'jsonField': 'organizationalUnitToSave',
      // 'editable': '$functions.isNullOrStringSelectedSaveCircuit()',
      'type': 'UOSEARCH',
      'parameters': [
        {
          'identifier': 'byUser',
          'value': true
        }
      ],
      'showInfo': this.userService.getUserPreferences()?.mainViewPrefs?.showHelpTags
    } as FieldConfig;
  }

  private disableAddStepType(stepType: TypeStepDTO): boolean {
    let disabled = false;
    const currentState = this.model.document?.currentState?.identifier;
    switch (stepType) {
      case TypeStepDTO.Revisa: {
        if (this.model.procedureCircuit?.orderNumber) {
          if (!currentState) {
            console.error('No se dispone del estado actual del documento por lo que no se puede activar la tarea de revision', document)
            disabled = true;
          } else {
            disabled = this.isDocumentStateValidOk(currentState) || this.isDocumentStateSignedOk(currentState);
          }
        }
        break;
      }
      case TypeStepDTO.Valida: {
        if (this.model.procedureCircuit?.orderNumber) {
          if (!currentState) {
            console.error('No se dispone del estado actual del documento por lo que no se puede activar la tarea de revision', document)
            disabled = true;
          } else {
            disabled = this.isDocumentStateSignedOk(currentState);
          }
        }
        break;
      }
      case TypeStepDTO.Cumplimenta: {
        disabled = this.existsStepType(TypeStepDTO.Cumplimenta);
        break;
      }
    }
    return disabled;
  }

  private isDocumentStateSignedOk(currentState: string): boolean {
    return currentState === '5' || currentState === '52';
  }

  private isDocumentStateValidOk(currentState: string): boolean {
    return currentState === '3' || currentState === '32' || currentState === '33';
  }

  private existsStepType(stepType: TypeStepDTO): boolean {
    return this.model?.procedureCircuit?.circuit?.config?.listCircuitStepDTO &&
      this.model.procedureCircuit.circuit.config.listCircuitStepDTO
        .find((step: CircuitStepDTO) => step.typeStep === stepType) !== undefined;
  }

  private searchCompany(onlyParticipants: boolean): void {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('General.search.company'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle',
      closable: false
    };
    if (onlyParticipants) {
      config.header = this.translateService.instant('ProcedureCircuit.CommAgent.ParticipantsCompanies');
      let parametersURL: ActionParameterDefinitionDTO[] = [];
      let param1 = new ActionParameterDefinitionDTO();
      param1.identifier = 'PROPUESTAID';
      param1.value = this.model?.procedureCircuit?.division?.project?.identifier;

      parametersURL.push(param1);
      config['context'] = new SearchSettingDTOModal('EMPRESAS_PARTICIPANTES_PROC', true, parametersURL);
    } else {
      config['context'] = new SearchSettingDTOModal('com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL');
    }
    // this.editDialogOpened.emit(true);
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose.pipe(
      tap((company: CompanyDTO) => {
        if (company) {
          let commAgent = new CircuitCommunicationAgentDTO();
          commAgent.type = CircuitCommunicationAgentTypeDTO.COMPANY;
          commAgent.company = company
          this.addReceiver(commAgent);
        }
      })
    ));
  }

  private addAliasReceiver(alias: ReceiverAlias): void {
    let commAgent = new CircuitCommunicationAgentDTO();
    commAgent.type = CircuitCommunicationAgentTypeDTO.ALIAS;
    commAgent.alias = alias;
    this.addReceiver(commAgent);
  }

  private addReceiver(receiver: CircuitCommunicationAgentDTO): void {
    if (!this.receiversModel) {
      this.receiversModel = [];
    }
    this.receiversModel.push(receiver);
    this.loadNotificationReceiverTypes();
  }

  private updateCircuitStepTypes(): void {
    if (!this.stepTypes) {
      this.stepTypes = [];
    }
    this.stepTypes.splice(0);
    this.stepTypes.push(...[
      {
        label: this.translateService.instant('Procedures.stepType.' + TypeStepDTO.Revisa),
        command: () => {
          this.addStep(TypeStepDTO.Revisa);
        },
        icon: 'fas fa-search',
        disabled: this.disableAddStepType(TypeStepDTO.Revisa)
      },
      {
        label: this.translateService.instant('Procedures.stepType.' + TypeStepDTO.Valida),
        command: () => {
          this.addStep(TypeStepDTO.Valida);
        },
        icon: 'fas fa-check',
        disabled: this.disableAddStepType(TypeStepDTO.Valida)
      },
      {
        label: this.translateService.instant('Procedures.stepType.' + TypeStepDTO.Firma),
        command: () => {
          this.addStep(TypeStepDTO.Firma);
        },
        icon: 'fas fa-file-signature',
        disabled: this.disableAddStepType(TypeStepDTO.Firma)
      },
      {
        label: this.translate.instant('ProcedureCircuit.Lbl.PublishStep'),
        command: () => {
          this.setShowPublicationsVisible(true);
        },
        icon: 'fas fa-cloud-upload-alt',
        disabled: this.existsPublicationStep()
      },
      {
        label: this.translate.instant('ProcedureCircuit.Lbl.CommStep'),
        command: () => {
          this.setShowNotificationsVisible(true);
        },
        icon: 'far fa-paper-plane',
        disabled: this.existsNotificationStep()
      }
    ]);
  }

  private loadNotificationReceiverTypes(): void {
    this.notificationReceiverTypes = [
      {
        label: this.getReceiverAliasDescription(ReceiverAlias.PENDING_INVITATIONS),
        command: () => {
          this.addAliasReceiver(ReceiverAlias.PENDING_INVITATIONS)
        },
        disabled: this.disableAliasReceiver(ReceiverAlias.PENDING_INVITATIONS),
        icon: 'fas fa-share'
      },
      {
        label: this.getReceiverAliasDescription(ReceiverAlias.RECEIVER_AWARDED),
        command: () => {
          this.addAliasReceiver(ReceiverAlias.RECEIVER_AWARDED)
        },
        disabled: this.disableAliasReceiver(ReceiverAlias.RECEIVER_AWARDED),
        icon: 'fas fa-award'
      },
      {
        label: this.getReceiverAliasDescription(ReceiverAlias.RECEIVER_NOTAWARDED),
        command: () => {
          this.addAliasReceiver(ReceiverAlias.RECEIVER_NOTAWARDED)
        },
        disabled: this.disableAliasReceiver(ReceiverAlias.RECEIVER_NOTAWARDED),
        icon: 'far fa-thumbs-down'
      },
      // {
      //   label: this.getReceiverAliasDescription(ReceiverAlias.RECEIVER_AWARD_ALL),
      //   command: () => {
      //     this.addAliasReceiver(ReceiverAlias.RECEIVER_AWARD_ALL)
      //   },
      //   disabled: this.disableAliasReceiver(ReceiverAlias.RECEIVER_AWARD_ALL),
      //   icon: 'fas fa-thumbs-down'
      // },
      {
        label: this.getReceiverAliasDescription(ReceiverAlias.RECEIVER_EXCLUDED),
        command: () => {
          this.addAliasReceiver(ReceiverAlias.RECEIVER_EXCLUDED);
        },
        disabled: this.disableAliasReceiver(ReceiverAlias.RECEIVER_EXCLUDED),
        icon: 'fas fa-ban'
      },
      {
        label: this.translateService.instant('ProcedureCircuit.CommAgent.ParticipantsCompanies'),
        command: () => {
          this.searchCompany(true);
        },
        icon: 'fas fa-industry'
      },
      {
        label: this.translateService.instant('ProcedureCircuit.CommAgent.Company'),
        command: () => {
          this.searchCompany(false);
        },
        icon: 'fas fa-industry'
      }
    ];
  }

  private disableAliasReceiver(type: ReceiverAlias): boolean {
    return this.receiversModel?.length > 0
      && this.receiversModel?.filter(receiver => receiver.type === CircuitCommunicationAgentTypeDTO.ALIAS)
        .find(receiver => receiver.alias === type) !== undefined;
  }

  public loadProfiles(): void {
    this.subscribe(this.loadProfilesObservable())
  }

  private loadProfilesObservable(): Observable<any> {
    let profileList = new Array<ProfileDTO>();
    return forkJoin([
      this.plycaService.query<ProfileDTO>(this.configuration.PROFILES_SERVICE_URL, {
        'aplication': this.project.application,
        'retrievAllProfilesApplicationData': 'true'
      }).pipe(
        catchError((error: any) => {
          this.errorHandler.showServerError(error);
          return throwError(error);
        }),
        tap((result: PaginationDTO<ProfileDTO>) => {
          if (result?.content) {
            // quitar administración, desarrollo y 71
            result.content
              .filter((profile: ProfileDTO) => this.isValidProfile(profile))
              .forEach((profile: ProfileDTO) => profileList.push(profile));
          }
        })
      ),
      iif(() => (this.model?.procedureCircuit?.division?.documentClass?.abbreviation === 'EXPLIC'
        || this.model?.procedureCircuit?.division?.documentClass?.abbreviation === 'EXP')
        && (getSimpleIdentifierFromString(this.model?.procedureCircuit?.division?.phase?.identifier) === '21'
          || getSimpleIdentifierFromString(this.model?.procedureCircuit?.division?.phase?.identifier) === '23'),
        this.plycaService.query<ProfileDTO>(this.configuration.PROFILES_SERVICE_URL, {
          'dynamic': 'true',
          'aplication': this.project.application
        }).pipe(
          catchError((error: any) => {
            this.errorHandler.showServerError(error);
            return throwError(error);
          }),
          tap((result: PaginationDTO<ProfileDTO>) => {
            if (result?.content) {
              result.content.forEach((profile: ProfileDTO) => profileList.push(profile));
            }
          })
        ),
        of(undefined)),
      iif(() => this.isAwardDivision(),
        this.plycaService.get<ProfileDTO>(this.configuration.PROFILES_SERVICE_URL, '71').pipe(
          catchError((error: any) => {
            this.errorHandler.showServerError(error);
            return throwError(error);
          }),
          tap((result: ProfileDTO) => {
            if (result) {
              profileList.push(result);
            }
          })
        ),
        of(undefined))
    ]).pipe(
      tap(() => {
        // ordenar lista de perfiles
        profileList = this.sortByString(profileList, 'description')
      }),
      finalize(() => this.profileList = profileList)
    );
  }

  private isAwardDivision(): boolean {
    return this.model?.procedureCircuit?.division?.documentClass?.abbreviation === 'EXPADJ'
      || this.model?.procedureCircuit?.division?.documentClass?.abbreviation === 'EXPADJEJEC'
      || this.model?.procedureCircuit?.division?.documentClass?.abbreviation === 'EXPINC';
  }

  private isValidProfile(profile: ProfileDTO): unknown {
    // tslint:disable-next-line:triple-equals
    return profile.identifier != '0' && profile.identifier != '50'
      // tslint:disable-next-line:triple-equals
      && profile.identifier != '71' && profile.identifier != '99'
      // tslint:disable-next-line:triple-equals
      && profile.identifier != '10' && profile.identifier != '80';
  }

  private sortByString(list: Array<any>, property: string): Array<any> {
    return list.sort(function (a, b) {
      const aProperty = a[property];
      const bProperty = b[property];
      if (aProperty < bProperty) {
        return -1;
      }
      if (aProperty > bProperty) {
        return 1;
      }
      return 0;
    });
  }

  private loadNotificationList(): Observable<Array<CircuitCommunicationDTO>> {
    let obs: Observable<any>;
    if (!this.model.notificationConfig) {
      obs = this.plycaService.simpleGet(this.configuration.PROCEDURECIRCUIT_SERVICE_URL + 'avaliable/notifications').pipe(
        tap((comms: CircuitCommunicationDTO[]) => this.model.notificationConfig = comms)
      );
    } else {
      // si vengo de tarea las opciones disponibles vienen en el work
      obs = of(this.model.notificationConfig);
    }
    return obs.pipe(
      tap((comms: Array<CircuitCommunicationDTO>) => {
        this.notificactionItems = this.communicationToMenuItem(comms);
      })
    );
  }

  private loadNotificationAgents(): Observable<any> {
    let obs: Observable<any>;
    if (this.model.companyTaxIdentifier) {
      obs = this.plycaService.query<CompanyDTO>(this.configuration.COMPANY_SERVICE_URL, {
        expand: undefined,
        taxIdentifier: this.model.companyTaxIdentifier,
        exactTaxIdentifier: 'true'
      }).pipe(
        tap((result: PaginationDTO<CompanyDTO>) => {
          if (result?.content) {
            this.notificationCompany = result.content[0];
          }
        })
      );
    } else if (false) {
      // TODO cargar alias
    } else {
      obs = of({});
    }
    return obs;
  }

  private loadPublicationList(): Observable<Array<CircuitCommunicationDTO>> {
    let obs: Observable<any>;
    if (!this.model.publishConfig) {
      obs = this.plycaService.simpleGet(this.configuration.PROCEDURECIRCUIT_SERVICE_URL + 'avaliable/publications').pipe(
        tap((comms: CircuitCommunicationDTO[]) => this.model.publishConfig = comms)
      );
    } else {
      obs = of(this.model.publishConfig);
    }
    return obs.pipe(
      finalize(() => {
        this.publicationItems = this.communicationToMenuItem(this.model.publishConfig);
      })
    );
  }
  private communicationToMenuItem(comms: CircuitCommunicationDTO[]): Array<SelectItem> {
    let items = new Array<SelectItem>();
    if (comms) {
      comms.forEach((comm: CircuitCommunicationDTO) => {
        items.push({
          value: comm,
          label: '(' + comm?.channel?.description + ') - ' + comm?.activity?.description
        });
      }
      );
    }
    return items;
  }

  private loadDocument(): Observable<any> {
    if (this.model.procedureCircuit?.division?.identifier
      && this.project?.identifier
      && this.model.procedureCircuit?.orderNumber
      && this.model.procedureCircuit?.circuit?.documentClass?.identifier) {

      return this.plycaService.query<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, {
        division: getSimpleIdentifierFromString(this.model?.procedureCircuit?.division.identifier),
        dossierId: this.project.identifier,
        orderNumber: '' + this.model.procedureCircuit.orderNumber,
        documentClasses: this.model.procedureCircuit.circuit.documentClass.identifier,
        expand: 'currentVersion'
      }).pipe(
        map((documentPage: PaginationDTO<DocumentDTO>) => {
          if (documentPage?.content) {
            return documentPage.content[0];
          } else {
            this.uiService.showMessage(this.translate.instant('ProcedureCircuit.Error.Document'), this.translateService.instant('General.error'));
            return of(undefined);
          }
        }),
        tap((document: DocumentDTO) => this.model.document = document)
      );
    } else {
      return of(undefined);
    }
  }

  private cloneAndCleanCircuit(circuit: CircuitDTO): CircuitDTO {
    let clonedObj = lodash.cloneDeep(circuit);
    this.cleanCircuitSteps(clonedObj?.config?.listCircuitStepDTO);
    return clonedObj;
  }

  private cleanCircuit(circuit: CircuitDTO): void {
    if (circuit) {
      if (this.addDocumentSelection) {
        // limpiar paso de cumplimentar
        circuit.config.listCircuitStepDTO = circuit.config.listCircuitStepDTO
          .filter((step: CircuitStepDTO) => step.typeStep !== TypeStepDTO.Cumplimenta);
      } else {
        // limpiar paso de anexar
        circuit.config.listCircuitStepDTO = circuit.config.listCircuitStepDTO
          .filter((step: CircuitStepDTO) => step.typeStep !== TypeStepDTO.Anexa);
      }
      this.cleanCircuitSteps(circuit?.config?.listCircuitStepDTO);
      // limpiar publicaciones si no se ha seleccionado nada
      if (circuit.config?.publications?.length > 0) {
        const selectedComm = circuit.config.publications.filter((comm: CircuitCommunicationDTO) =>
          comm.activity.identifier !== undefined && comm.channel.identifier !== undefined);
        circuit.config.publications.splice(0);
        circuit.config.publications.push(...selectedComm);
      }
    }
  }

  private cleanCircuitSteps(steps: Array<CircuitStepDTO>): void {
    if (steps) {
      steps.forEach((step: CircuitStepDTO) => {
        step[STEP_PROFILE_PROPERTY] = undefined;
        step[OU_PROFILE_PROPERTY] = undefined;
      });
    }
  }

  public addMessageStep(type: TypeStepDTO, index: number): void {
    let messageStepType: TypeStepDTO;
    switch (type) {
      case TypeStepDTO.Cumplimenta: {
        messageStepType = TypeStepDTO.MsgCumplimenta;
        break;
      }
      case TypeStepDTO.Revisa: {
        messageStepType = TypeStepDTO.MsgRevisa;
        break;
      }
      case TypeStepDTO.Valida: {
        messageStepType = TypeStepDTO.MsgValida;
        break;
      }
      case TypeStepDTO.Firma: {
        messageStepType = TypeStepDTO.MsgFirma;
        break;
      }
    }
    const newStep = this.addStep(messageStepType, index);
    if (newStep) {
      const newStepIndex = this.model.procedureCircuit.circuit.config.listCircuitStepDTO.indexOf(newStep);
      let defaultMessage = this.translateService.instant('ProcedureCircuit.Msg.Defaul');
      newStep.idMessage = defaultMessage;
    }
  }

  private addStep(type: TypeStepDTO, index?: number): CircuitStepDTO {
    let newStep: CircuitStepDTO;
    if (type) {
      if (index) {
        newStep = this.createNewStep(type);
        this.model.procedureCircuit.circuit.config.listCircuitStepDTO.splice(index, 0, newStep);
      } else {
        let stepAdded = false;
        let finalSteps = new Array<CircuitStepDTO>();
        let steps = this.model?.procedureCircuit?.circuit?.config?.listCircuitStepDTO;
        if (steps) {
          const stepLevel = this.getTypeStepDTOLevel(type);
          steps.forEach((circuitStep: CircuitStepDTO) => {
            const circuitStepLevel = this.getTypeStepDTOLevel(circuitStep.typeStep);
            if (circuitStepLevel < stepLevel || circuitStepLevel === stepLevel) {
              finalSteps.push(circuitStep);
            } else {
              if (!stepAdded) {
                newStep = this.createNewStep(type);
                finalSteps.push(newStep);
                // marcar añadido
                stepAdded = true
              }
              finalSteps.push(circuitStep);
            }
          });
        } else {
          this.model.procedureCircuit.circuit.config.listCircuitStepDTO = [];
        }
        if (!stepAdded) {
          newStep = this.createNewStep(type);
          finalSteps.push(newStep);
        }
        this.model.procedureCircuit.circuit.config.listCircuitStepDTO.splice(0);
        this.model.procedureCircuit.circuit.config.listCircuitStepDTO.push(...finalSteps);
        // actulizar listado de pasos disponibles
        this.updateCircuitStepTypes();
      }
    }
    return newStep;
  }

  private createNewStep(type: TypeStepDTO): CircuitStepDTO {
    // añadir nuevo paso
    const newStep = new CircuitStepDTO();
    newStep.typeStep = type;
    return newStep;
  }

  public removeStep(index: number): void {
    let steps = this.model?.procedureCircuit?.circuit?.config?.listCircuitStepDTO;
    if (steps) {
      let stepToRemove = steps[index];
      if (stepToRemove.typeStep === TypeStepDTO.Cumplimenta) {
        stepToRemove.inbox = undefined;
        stepToRemove.profile = undefined;
      } else {
        let messageStep: CircuitStepDTO;
        if (steps.length > index + 1 && this.isMessageStep(steps[index + 1])) {
          messageStep = steps[index + 1];
        }
        this.model.procedureCircuit.circuit.config.listCircuitStepDTO = steps
          .filter((circuitStep: CircuitStepDTO) => circuitStep !== stepToRemove && circuitStep !== messageStep);
      }
      this.updateCircuitStepTypes();
    }
  }

  public getProfileFieldConfig(index: number, stepModel: CircuitStepDTO): FieldConfig {
    stepModel[STEP_PROFILE_PROPERTY] = this.profileList;
    let config = lodash.cloneDeep(this.profileFieldConfig);
    config.id = 'profile_' + index;
    return config;
  }

  public suggestInbox(stepModel: CircuitStepDTO): void {
    if (!stepModel?.profile) {
      stepModel.inbox = undefined;
    } else if (this.model.inboxSugestions?.length > 0) {
      // tslint:disable-next-line:triple-equals
      if (stepModel.profile?.identifier == '71') {
        stepModel.inbox = undefined;
      } else {
        let suggestedInbox = this.model.inboxSugestions.find((suggestion: ProfileInboxDTO) =>
          suggestion.profile?.identifier === stepModel.profile.identifier);
        stepModel.inbox = (suggestedInbox !== undefined) ? suggestedInbox.inbox : undefined;
      }
    }
  }

  public getInboxFieldConfig(index: number, stepModel: CircuitStepDTO): FieldConfig {
    let defaultOrganizarionalUnit = this.model.procedureCircuit?.circuit?.organizationalUnit;
    if (!defaultOrganizarionalUnit) {
      // si no hay unidad organica por defecto se pone la del usuario
      defaultOrganizarionalUnit = this.userService.getUser()?.organizationalUnit;
    }
    stepModel[OU_PROFILE_PROPERTY] = defaultOrganizarionalUnit;
    let config = lodash.cloneDeep(this.inboxFieldConfig);
    config.id = 'inbox_' + index;
    return config;
  }

  public getMessageTextFieldConfig(index: number): FieldConfig {
    let config = lodash.cloneDeep(this.messageTextFieldConfig);
    config.id = 'message_' + index;
    return config;
  }

  private orderCircuitSteps(circuit: CircuitDTO): void {
    if (circuit?.config?.listCircuitStepDTO?.length > 0) {
      circuit?.config?.listCircuitStepDTO.sort((a, b) =>
        this.getTypeStepDTOLevel(a.typeStep) - this.getTypeStepDTOLevel(b.typeStep));
    }
  }

  private getTypeStepDTOLevel(type: TypeStepDTO): number {
    let index = 0;
    switch (type) {
      case TypeStepDTO.Anexa:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgAnexa:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.Cumplimenta:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgCumplimenta: {
        index = 1;
        break;
      }
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.Revisa:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgRevisa: {
        index = 2;
        break;
      }
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.Corrige:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgCorrige: {
        index = 3;
        break;
      }
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.Valida:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgValida: {
        index = 4;
        break;
      }
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.Firma:
      // tslint:disable-next-line:no-switch-case-fall-through
      case TypeStepDTO.MsgFirma: {
        index = 5;
        break;
      }
    }
    return index;
  }

  private accept(): void {
    this.waitService.startWaiting();
    let obs = this.saveProcedureCircuit();
    this.subscribe(obs.pipe(
      switchMap((procCircuit: ProcedureCircuitDTO) => {
        let returnObs: Observable<any>;
        if (!procCircuit?.validationResult || procCircuit?.validationResult.result === ResultTypeDTO.OK) {
          if (this.task) {
            returnObs = this.processTaskObservable();
          } else {
            returnObs = this.plycaService.put(this.configuration.PROCEDURECIRCUIT_SERVICE_URL +
              procCircuit.identifier + '/start').pipe(
                catchError((error: any) => {
                  this.uiService.showMessage(this.translateService.instant('ProcedureCircuit.Error.Start')
                    , this.translateService.instant('General.error')
                    , 'errorStyle');
                  return throwError(error);
                }),
                tap(() => this.dialogRef.close(true))
              );
          }
        } else if (procCircuit?.validationResult) {
          // mostrar errores
          this.formPlycaRef.manageFormException(procCircuit.validationResult);
          returnObs = EMPTY;
        }
        return returnObs;
      }),
      finalize(() => this.waitService.cancelWaiting())
    ))
  }

  protected getTask(): TaskDTO {
    // solo necesitamos enviar el identificador de circuito almacenado porque es un work reactivo
    let taskToSave = lodash.cloneDeep(this.task);
    if (taskToSave.work) {
      taskToSave.work.circuitsDocuments = undefined;
      taskToSave.work.orderNumber = undefined;
      taskToSave.work.phase = undefined;
      taskToSave.work.mustBePublished = undefined;
      taskToSave.work.notificationConfig = undefined;
      taskToSave.work.mustBeNotified = undefined;
      taskToSave.work.publishConfig = undefined;
      taskToSave.work.companyTaxIdentifier = undefined;
      taskToSave.work.inboxSugestions = undefined;
      if (taskToSave.work.procedureCircuit) {
        taskToSave.work.procedureCircuit.circuit = undefined;
        taskToSave.work.procedureCircuit.division = undefined;
        taskToSave.work.procedureCircuit.procedure = undefined;
        taskToSave.work.procedureCircuit.task = undefined;
        taskToSave.work.procedureCircuit.orderNumber = undefined;
      }
    }
    return taskToSave;
  }

  private saveProcedureCircuit(): Observable<ProcedureCircuitDTO> {
    let obs: Observable<ProcedureCircuitDTO>;
    let procedureCircuit = this.model?.procedureCircuit;
    if (procedureCircuit) {
      if (procedureCircuit.identifier) {
        obs = this.saveContext(false, undefined, 'UpdateDefProcedure');
      } else {
        obs = this.insertContext(false, undefined, 'InsertDefProcedure').pipe(
          tap((updated: ProcedureCircuitDTO) => {
            this.model.procedureCircuit.identifier = updated.identifier;
          })
        );
      }
      obs = obs.pipe(
        catchError(() => EMPTY)
      )
    } else {
      obs = of(undefined);
    }
    return obs;
  }

  public isVisibleAddMsgStep(allSteps: CircuitStepDTO[], idx: number): boolean {
    let typeStep: TypeStepDTO;
    if (allSteps?.length > 0) {
      typeStep = allSteps[idx].typeStep;
    }
    return this.model.procedureCircuit?.circuit?.config?.advancedMode && (typeStep === TypeStepDTO.Cumplimenta
      || typeStep === TypeStepDTO.Revisa
      || typeStep === TypeStepDTO.Valida
      || typeStep === TypeStepDTO.Firma);
  }

  public isDisabledAddMsgStep(allSteps: CircuitStepDTO[], idx: number): string {
    return this.isNextMessageStep(allSteps, idx) ? 'disabled' : undefined;
  }

  public isMessageStep(step: CircuitStepDTO): boolean {
    let stepType = (step) ? step.typeStep : undefined
    return stepType === TypeStepDTO.MsgCumplimenta
      || stepType === TypeStepDTO.MsgRevisa
      || stepType === TypeStepDTO.MsgValida
      || stepType === TypeStepDTO.MsgFirma
  }

  public isNextMessageStep(allSteps: CircuitStepDTO[], idx: number): boolean {
    let nextStep: CircuitStepDTO;
    if (allSteps?.length > 0) {
      if ((allSteps.length - 1) > idx) {
        nextStep = allSteps[idx + 1];
      }
    }
    return this.isMessageStep(nextStep);
  }

  public getReceiverDescription(receiver: CircuitCommunicationAgentDTO): string {
    let description: string;
    if (receiver.type === CircuitCommunicationAgentTypeDTO.COMPANY) {
      description = (receiver.company?.commercialName) ? receiver.company.commercialName : receiver.company.name;
    } else {
      description = this.getReceiverAliasDescription(receiver.alias);
    }
    return description;
  }

  private getReceiverAliasDescription(alias: string): string {
    return this.translateService.instant('ProcedureCircuit.CommAgent.Alias.' + alias)
  }

  public removePublications(): void {
    if (!this.model.mustBePublished) {
      this.setShowPublicationsVisible(false);
    }
  }

  public removeNotifications(): void {
    if (!this.model.mustBeNotified) {
      this.setShowNotificationsVisible(false);
    }
    this.loadNotificationReceiverTypes();
  }


  public removeReceiver(receiverToRemove: CircuitCommunicationAgentDTO): void {
    if (this.receiversModel.length > 0) {
      this.receiversModel = this.receiversModel.filter((receiver: CircuitCommunicationAgentDTO) => receiver !== receiverToRemove);
      this.loadNotificationReceiverTypes();
    }
  }

  private setShowPublicationsVisible(visible: boolean) {
    this.showPublications = visible;
    if (visible) {
      this.initPublicationsPanelForEdition();
    } else if (this.model?.procedureCircuit?.circuit?.config?.publications) {
      this.model.procedureCircuit.circuit.config.publications.splice(0);
    }
    this.updateCircuitStepTypes();
  }

  private setShowNotificationsVisible(visible: boolean) {
    this.showNotifications = visible;
    if (visible) {
      this.initNotificationsPanelForEdition();
    } else if (this.model?.procedureCircuit?.circuit?.config?.notifications) {
      this.model.procedureCircuit.circuit.config.notifications.splice(0);
    }
    this.updateCircuitStepTypes();
  }

  setShowSaveCircuit(visible: boolean) {
    if (visible) {
      this.showSaveCircuit = true;
      this.selectedSaveCircuit = null;
      this.organizationalUnitToSave = this.userService.getUser()?.organizationalUnit;
    } else {
      this.showSaveCircuit = false;
    }
  }

  public existsNotificationStep(): boolean {
    return this.model?.procedureCircuit?.circuit?.config?.notifications?.length > 0;
  }
  public existsPublicationStep(): boolean {
    return this.model?.procedureCircuit?.circuit?.config?.publications?.length > 0;
  }


  private initCircuitConfiguration() {
    if (!this.model.procedureCircuit.circuit.config) {
      this.model.procedureCircuit.circuit.config = new CircuitConfigDTO();
    }
    if (!this.model.procedureCircuit.circuit.config.listCircuitStepDTO) {
      this.model.procedureCircuit.circuit.config.listCircuitStepDTO = [];
    } else {
      this.model.procedureCircuit.circuit.config.listCircuitStepDTO.splice(0);
    }
    this.receiversModel = undefined;
  }

  private initNotificationsPanelForEdition(): void {
    let notifications = this.model.procedureCircuit.circuit.config.notifications;
    if (!notifications) {
      notifications = [];
      this.model.procedureCircuit.circuit.config.notifications = notifications;
    }
    notifications.splice(0);
    if (this.model.notificationConfig?.length === 1) {
      notifications.push(this.model.notificationConfig[0]);
    } else {
      notifications.push(new CircuitCommunicationDTO());
    }
    if (this.notificationCompany) {
      const receiver = new CircuitCommunicationAgentDTO();
      receiver.type = CircuitCommunicationAgentTypeDTO.COMPANY;
      receiver.company = this.notificationCompany;
      let receivers = notifications[0].receivers;
      if (!receivers) {
        receivers = [];
        notifications[0].receivers = receivers;
      }
      receivers.push(receiver);
    }
  }

  private initPublicationsPanelForEdition(): void {
    let publications = this.model.procedureCircuit.circuit.config.publications;
    if (!publications) {
      publications = [];
      this.model.procedureCircuit.circuit.config.publications = publications;
    }
  }

  public applyCircuit(): void {
    if (this.circuitToImport) {
      if (!this.isCircuitDefinitionEmpty()) {
        this.confirmationService.confirm({
          header: this.translateService.instant('General.warn'),
          message: this.translate.instant('ProcedureCircuit.Msg.ImportConfirm'),
          acceptLabel: this.translateService.instant('General.yes'),
          rejectLabel: this.translateService.instant('General.no'),
          accept: () => {
            this.showImportCircuit = false;
            this.setCircuit(this.circuitToImport);
          },
          reject: () => {
            this.showImportCircuit = false;
          }
        })
      } else {
        this.showImportCircuit = false;
        this.setCircuit(this.circuitToImport);
      };
    }
  }

  private setCircuit(circuitToImport: CircuitDTO) {
    this.model.procedureCircuit.circuit.config = lodash.cloneDeep(circuitToImport.config);
    // aplicar circuitos sugeridos
    if (this.model.procedureCircuit.circuit?.config?.listCircuitStepDTO?.length > 0) {
      this.model.procedureCircuit.circuit.config.listCircuitStepDTO
        .forEach((step: CircuitStepDTO) => {
          this.suggestInbox(step);
        });
    }
    // Si el circuito tiene destinatarios distintos a empresas concretas se importan en el circuito actual
    if (circuitToImport.config.notifications?.length > 0) {
      this.receiversModel = circuitToImport.config?.notifications[0]?.
        receivers.filter(x => x.type !== CircuitCommunicationAgentTypeDTO.COMPANY);
    }
    this.setAdvancedMode(this.model);
    this.updatePublicationsAndNotificationsVisibility();
  }

  private setAdvancedMode(model: WorkProcedureCircuitDTO) {
    if (model?.procedureCircuit?.circuit?.config) {
      model.procedureCircuit.circuit.config.advancedMode = true;
    }
  }

  public changeAddDocument(event: { originalEvent?: Event, value: boolean }): void {
    this.addDocumentSelection = event.value;
    const stepType = (event.value) ? TypeStepDTO.Anexa : TypeStepDTO.Cumplimenta;
    if (!this.existsStepType(stepType)) {
      const addStep = new CircuitStepDTO();
      addStep.typeStep = stepType;
      this.model.procedureCircuit.circuit.config.listCircuitStepDTO.splice(0, 0, addStep);
    }
  }

  public showAddDocument(): void {
    const config: DynamicDialogConfig = {
      header: this.translate.instant('General.search.results'),
      width: '80%',
      height: '80%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      data: {
        dossierId: this.project.identifier,
        documentClass: this.model.procedureCircuit?.circuit?.documentClass,
        division: this.model?.procedureCircuit?.division,
        phase: this.model?.procedureCircuit?.circuit?.phase,
        locale: this.locale
      }
    };
    let ref = this.dialogService.open(basicDocumentComponent, config);
    this.subscribe(ref.onClose.pipe(
      tap((document: DocumentDTO) => {
        this.model.document = document;
        this.model.procedureCircuit.orderNumber = this.model.document.entity.orderNumber;
      }),
      switchMap(() => this.saveProcedureCircuit().pipe(
        finalize(() => {
          this.waitService.cancelWaiting();
          this.changeDetectorRef.detectChanges();
        })
      ))
    ));
  }

  public showDocument(): void {
    // let commDoc = event.value as CommunicationDocumentDTO;
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Navigation.documentViewer'),
      width: '97%',
      styleClass: 'helpStyle'
    };
    let docVersion = this.model.document.currentVersion; // as DocumentVersionDTO;
    if (docVersion) {
      config.data = {
        'id': this.model.document.identifier
      }
      const ref = this.dialogService.open(documentViewerComponent, config);
      this.subscribe(ref.onClose);
    }
  }

  public deleteDocument(): void {
    this.waitService.startWaiting();
    let url = this.configuration.DOCUMENT_EVENT_URL.replace('{documentIdentifier}', this.model.document.identifier);
    url = url.replace('{eventId}', 'CancelDocument') + '?force=true';
    this.subscribe(this.plycaService.simpleUpdate(url, new Object()).pipe(
      catchError((error: any) => {
        this.uiService.showMessage(this.translateService.instant('ProcedureCircuit.Error.DeleteDoc')
          , this.translateService.instant('General.error')
          , 'errorStyle');
        return throwError(error);
      }),
      tap(() => {
        this.model.document = undefined;
        this.model.procedureCircuit.orderNumber = undefined;
      }),
      switchMap(() => this.saveProcedureCircuit()),
      finalize(() => {
        this.waitService.cancelWaiting();
        this.changeDetectorRef.detectChanges();
      })
    ));
  }

  private isCircuitDefinitionEmpty(): boolean {
    return (!this.model.procedureCircuit?.circuit?.config?.listCircuitStepDTO
      // no hay tareas/pasos definidas
      || this.model.procedureCircuit?.circuit?.config?.listCircuitStepDTO?.length === 0
      // o hay paso de anexar sin documento
      || (this.model.procedureCircuit?.circuit?.config?.listCircuitStepDTO?.length === 1
        && this.existsStepType(TypeStepDTO.Anexa)
        && this.model.procedureCircuit?.orderNumber === undefined
      )
    )
      // no hay notificaciones
      && (!this.model.procedureCircuit?.circuit?.config?.notifications
        || this.model.procedureCircuit?.circuit?.config?.notifications?.length === 0)
      // no hay comnunicaciones
      && (!this.model.procedureCircuit?.circuit?.config?.publications
        || this.model.procedureCircuit?.circuit?.config?.publications?.length === 0)
  }

  public visibleStepsExists(): boolean {
    return this.model.procedureCircuit?.circuit?.config?.listCircuitStepDTO?.length === 1 &&
      this.existsStepType(TypeStepDTO.Cumplimenta)
      || this.model.procedureCircuit?.circuit?.config?.listCircuitStepDTO?.length > 1;
  }

  private isNullOrStringSelectedSaveCircuit(): boolean {
    return this.isNullOrStringCircuit(this.selectedSaveCircuit);
  }

  private isNullOrStringCircuit(circuit: any): boolean {
    return circuit === undefined || typeof circuit === 'string' || !circuit?.identifier;
  }

  public getUnitFieldFunctions(): Array<FunctionDef> {
    let fn = new FunctionDef();
    fn.fn = this.isNullOrStringSelectedSaveCircuit.bind(this);
    fn.identifier = 'isNullOrStringSelectedSaveCircuit';
    return [fn];
  }

  public changeSaveCircuitName(event: { originalEvent?: Event, value: any }): void {
    if (this.isNullOrStringCircuit(event.value)) {
      this.organizationalUnitToSave = this.userService.getUser().organizationalUnit;
    } else if (event.value?.organizationalUnit) {
      this.organizationalUnitToSave = event.value?.organizationalUnit;
    }
  }

  public getProject(): string {
    return (this.project) ? this.project.identifier : '';
  }

}
